import filter from 'lodash/filter';

import {
  SIMPLE_CHOICE,
  SIMPLE_CHOICE_META,
} from '@/features/ChoicesLists/Simple/types';
import type { FeatureGroup } from '@/features/Features';
import { useFeaturesStore } from '@/features/Features';
import { useResInputStore } from '@/features/Sparten/res/useInputStore';
import { getSimpleChoiceMeta } from '@/utils/getSimpleChoiceMeta/getSimpleChoiceMeta';

interface StandardRubriken {
  rubrik1: boolean[];
  rubrik2: boolean[];
  rubrik3: boolean[];
  rubrik4: boolean[];
  rubrik5: boolean[];
  rubrik6: boolean[];
  rubrik7: boolean[];
  rubrik8: boolean[];
}

export const featureFilterFunction = (): FeatureGroup[] => {
  const { leistungsumfang, tarifgruppe } = useResInputStore();

  const combiLeistungsumfangMietenPrivatSelected =
    leistungsumfang.privat && leistungsumfang.mieten;

  const standardRubriken: StandardRubriken = {
    rubrik1: [leistungsumfang.privat, leistungsumfang.beruf],
    rubrik2: [leistungsumfang.privat, leistungsumfang.beruf],
    rubrik3: [leistungsumfang.privat, leistungsumfang.beruf],
    rubrik4: [leistungsumfang.privat, leistungsumfang.beruf],
    rubrik5: [leistungsumfang.privat, leistungsumfang.beruf],
    rubrik6: [leistungsumfang.verkehr],
    rubrik7: [combiLeistungsumfangMietenPrivatSelected],
    rubrik8: [leistungsumfang.privat, leistungsumfang.beruf],
  };

  const merkmaleForTarifgruppeSingle = [
    'rubrik9',
    'rubrik10',
    'rubrik11',
    'rubrik12',
    'rubrik13',
  ];
  const merkmaleForTarifgruppeFamilie = [
    'rubrik14',
    'rubrik15',
    'rubrik16',
    'rubrik17',
    'rubrik18',
  ];

  const combiLeistungsumfangVerkehrSelected =
    !leistungsumfang.privat &&
    !leistungsumfang.beruf &&
    !leistungsumfang.mieten &&
    !leistungsumfang.vermietung &&
    leistungsumfang.verkehr;

  const combiLeistungsumfangMietenOrVermietungSelected =
    !leistungsumfang.privat &&
    !leistungsumfang.beruf &&
    !leistungsumfang.verkehr &&
    (leistungsumfang.mieten || leistungsumfang.vermietung);

  const combiLeistungsumfangVerkehrMietenOrVermietungSelected =
    !leistungsumfang.privat &&
    !leistungsumfang.beruf &&
    leistungsumfang.verkehr &&
    (leistungsumfang.mieten || leistungsumfang.vermietung);

  const features = useFeaturesStore().data as FeatureGroup[];

  if (
    combiLeistungsumfangVerkehrSelected ||
    combiLeistungsumfangVerkehrMietenOrVermietungSelected
  ) {
    const isTarifgruppeFamilie = getSimpleChoiceMeta(
      SIMPLE_CHOICE.RES_TARIFGRUPPE,
      SIMPLE_CHOICE_META.RES_TARIFGRUPPE_IS_FAMILY,
    ).includes(tarifgruppe);

    return filter(
      features,
      (feature) =>
        !!(
          (merkmaleForTarifgruppeSingle.includes(feature.rubrik) &&
            !isTarifgruppeFamilie) ||
          (merkmaleForTarifgruppeSingle.includes(feature.rubrik) &&
            isTarifgruppeFamilie &&
            !leistungsumfang.hasMehrereFahrzeuge) ||
          (merkmaleForTarifgruppeFamilie.includes(feature.rubrik) &&
            isTarifgruppeFamilie &&
            leistungsumfang.hasMehrereFahrzeuge)
        ),
    );
  }

  if (combiLeistungsumfangMietenOrVermietungSelected) {
    return filter(features, (feature) => feature.rubrik === 'rubrik1');
  }

  return filter(features, (feature) => {
    const currentRubrik =
      standardRubriken[feature.rubrik as keyof StandardRubriken];

    if (currentRubrik !== undefined) {
      for (let i = 0; i < currentRubrik.length; i += 1) {
        if (currentRubrik[i]) {
          return true;
        }
      }
    }

    return false;
  });
};
